import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_all_wrkrs_offered_any_of_the_following_types_of_market_acce'

export const dataPointDefinition = {
  retracedId: 'are_all_wrkrs_offered_any_of_the_following_types_of_market_acce',
  name: 'Are all workers offered any of the following types of market access programs by the facility?:',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'FINANCIAL_LITERACY_PROGRAMS',
      text: 'Financial Literacy Programs',
      externalIds: [
        {
          id: 'ab-2-1x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PLEASE_DESCRIBE_',
      text: 'Please describe:',
      externalIds: [
        {
          id: 'ab-2-1f',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'DIGITAL_PAYMENT_ASSISTANCE',
      text: 'Digital Payment Assistance',
      externalIds: [
        {
          id: 'ab-2-2x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PLEASE_DESCRIBE_',
      text: 'Please describe:',
      externalIds: [
        {
          id: 'ab-2-2f',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'HOME_FINANCING_PROGRAM',
      text: 'Home Financing Program',
      externalIds: [
        {
          id: 'ab-2-3x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'PLEASE_DESCRIBE_',
      text: 'Please describe:',
      externalIds: [
        {
          id: 'ab-2-3f',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ab-2-4x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ab-2-4f',
            version: '1.4.0',
            provider: 'slcp',
          },
        ],
      },
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'ab-2-5x',
          version: '1.4.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'FINANCIAL_LITERACY_PROGRAMS',
                'PLEASE_DESCRIBE_',
                'DIGITAL_PAYMENT_ASSISTANCE',
                'HOME_FINANCING_PROGRAM',
                'OTHER',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ab-wor-4',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 24300,
  sectionId: '2.2.2.2',
  impactArea: 'Worker Wellbeing',
  impactAreaId: 'WORKER_WELLBEING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
